export const setupSteps = [
  { key: "welcome", title: "Welcome", icon: "rocket-launch-outline", canSkip: false },
  { key: "assistant", title: "AI assistant", icon: "robot", canSkip: true },
  { key: "extensions", title: "Extensions", icon: "account-multiple-outline", canSkip: true },
  { key: "ringgroups", title: "Ring groups", icon: "phone-incoming-outline", canSkip: true },
  { key: "ivr", title: "IVR menus", icon: "menu", canSkip: true },
  { key: "phonenumber", title: "Phone number", icon: "phone-plus-outline", canSkip: true },
];
